import { useContext } from 'react'
import { GETNET, KLAP, WEBPAY } from '../../constants/payment'
import { useGetnet } from './gateways/useGetnet'
import { useKlap } from './gateways/useKlap'
import { useWebpay } from './gateways/useWebpay'
import { usePayment } from './usePayment/usePayment'
import { DataContext } from '../../context/DataContext'

export const usePay = () => {
  const { setShowFinalLoader } = useContext(DataContext)
  const {
    gateway,
    isSavingCard,
    useOneClick,
    selectedPaymentCard,
    setPaymentState,
    setIsPaying
  } = usePayment()

  const { subscribeCardAndPayGetnet, payWithGetnet, payOneClickWithGetnet } =
    useGetnet()
  const {
    payWithWebpay,
    subscribeCardAndPayWebpay,
    payOneClickWithWebpay,
    confirmPaymentMethodWithWebpay
  } = useWebpay()
  const { payWithKlap, payOneClickWithKlap, confirmPaymentMethodWithKlap } = useKlap()

  const handleConfirmPinflagPaymentMethod = async () => {
    if (useOneClick) {
      return await handleGoToPayWithOneClick()
    }
    if (isSavingCard) {
      await handleGoToSubscribreCardAndPay()
    } else {
      await handleGoToPayAsGuestWithGateway()
    }
  }

  const handleGoToSubscribreCardAndPay = async () => {
    switch (gateway) {
      case GETNET:
        return await subscribeCardAndPayGetnet()
      case WEBPAY:
        return await subscribeCardAndPayWebpay()
      default:
        return null
    }
  }

  const handleGoToPayAsGuestWithGateway = async () => {
    switch (gateway) {
      case GETNET:
        return await payWithGetnet()
      case WEBPAY:
        return await confirmPaymentMethodWithWebpay()
      case KLAP:
        return await confirmPaymentMethodWithKlap()
      default:
        return console.log('TODO: Handle handleGoToPayAsGuestWithGateway')
    }
  }

  const handleGoToPayWithOneClick = async () => {
    setShowFinalLoader(true)
    const { paymentGateway, paymentMethod } = selectedPaymentCard
    setPaymentState((prevState) => ({
      ...prevState,
      paymentMethod,
      gateway: paymentGateway,
      isPaying: true
    }))
    switch (paymentGateway) {
      case GETNET:
        return await payOneClickWithGetnet()
      case KLAP:
        return await payOneClickWithKlap()
      case WEBPAY:
        return await payOneClickWithWebpay()
      default:
        return console.log('TODO: Handle handleGoToPayWithOneClick')
    }
  }

  const handleConfirmPayment = async () => {
    setIsPaying(true)
    switch (gateway) {
      case WEBPAY:
        return await payWithWebpay()
      case KLAP:
        return await payWithKlap()
      default:
        return null
    }
  }

  return {
    handleConfirmPinflagPaymentMethod,
    handleConfirmPayment
  }
}
